import Pusher from 'pusher-js'

const PUSHER_APP_KEY = process.env.NEXT_PUBLIC_PUSHER_KEY as string
const PUSHER_CLUSTER = process.env.NEXT_PUBLIC_PUSHER_CLUSTER

const pusher = new Pusher(PUSHER_APP_KEY, {
  cluster: PUSHER_CLUSTER,
})

// TODO: bind and listen to error and other relavents on the connection
// eg. https://github.com/pusher/pusher-js#connection

// this returns the same pusher client for the entire duration of the app (until hard refresh)
function getPusherClient(): Pusher {
  return pusher
}

export default getPusherClient
